import { USER, COMPANY_ADMIN, REGULATOR, SYS_ADMIN } from 'config/permissions/roles';

export default class AdverseEventsService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  setQuery(query) {
    this.query = query;
  }

  getAdverseEvents() {
    return this.$http.get('/api/ae/list', {
      params: {
        ...this.query
      }
    });
  }

  getAdverseEventsByReportDate(reportDate) {
    return this.$http.get('/api/ae/search_by_report_date', {
      params: {
        ...this.query,
        reportDate: reportDate.toISOString()
      }
    });
  }

  getAdverseEventsByProduct(productId) {
    return this.$http.get('/api/ae/search_by_product', {
      params: {
        ...this.query,
        productId
      }
    });
  }

  getAdverseEventsByMember(memberId) {
    return this.$http.get('/api/ae/search_by_member', {
      params: {
        ...this.query,
        memberId
      }
    });
  }

  getAdverseEventsByIngredient(ingredientId) {
    return this.$http.get('/api/ae/search_by_user_ingredient', {
      params: {
        ...this.query,
        userIngredientId: ingredientId
      }
    });
  }

  getAdverseEventsBySystemIngredient(systemIngredientId) {
    return this.$http.get('/api/ae/search_by_system_ingredient', {
      params: {
        ...this.query,
        systemIngredientId
      }
    });
  }

  getAdverseEventsByType(selectedSymptoms, shouldMatchAll) {
    const url = shouldMatchAll ? 'search_by_all_symptom' : 'search_by_any_symptom';

    return this.$http.get(`/api/ae/${url}`, {
      params: {
        ...this.query,
        selectedSymptoms
      }
    });
  }

  getAdverseEventsBySpecies(species) {
    return this.$http.get('/api/ae/search_by_species', {
      params: {
        ...this.query,
        selectedSpecies: species
      }
    });
  }

  getAdverseEventsMissingInfo() {
    return this.$http.get('/api/ae/search_by_missing_info', {
      params: {
        ...this.query
      }
    });
  }

  getAdverseEventsByText(text) {
    return this.$http.get('/api/ae/search_by_text', {
      params: {
        ...this.query,
        searchText: text
      }
    });
  }

  getAdverseEventsByStatus(status) {
    return this.$http.get('/api/ae/search_by_status', {
      params: {
        ...this.query,
        status
      }
    });
  }

  getEventTypes() {
    return [{
      name: 'Diarrhea',
      id: 0
    }, {
      name: 'Stomach Upset/Vomiting',
      id: 1
    }, {
      name: 'Colic (Horse)',
      id: 2
    }, {
      name: 'Skin/Allergic Reaction',
      id: 3
    }, {
      name: 'Seizures',
      id: 4
    }, {
      name: 'Death',
      id: 5
    }, {
      name: 'Lameness',
      id: 6
    }, {
      name: 'Accidental Ingestion',
      id: 7
    }, {
      name: 'Other',
      id: 8
    }];
  }

  getSearchTypes() {
    return [{
      name: 'All Adverse Events',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Open Adverse Events',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Report Date',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Product Name',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Ingredient Name',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by System Ingredient',
      permission: [`${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Event (any events)',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Event (all matched events)',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Member',
      permission: [`${SYS_ADMIN}`, `${REGULATOR}`]
    }, {
      name: 'Search by Species',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }, {
      name: 'Search by Text',
      permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    // }, {
    //   name: 'Missing Event Information',
    //   permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
    }];
  }

  getAlerts() {
    return this.$http.get('/api/alert/load_alert_ae');
  }

  getOpenAdverseEventsPreviousMonth() {
    return this.$http.get('/api/ae/previous_month');
  }
}



// WEBPACK FOOTER //
// ./services/adverse-events.service.js